export default __webpack_public_path__ + "static/media/blank-profile-picture.2fda6558.png";